import React, { useEffect, useState } from 'react';
import { Radio } from 'antd';

import styles from "./mapLocationPicker.scss"
import { getWindowWidth, isMobileScreen } from '../../../services/utils';
import { useZoomHint, ZOOM_HINT_STATE } from './hooks/useZoomHint';
import { useOpenLayerMap } from './hooks/useOpenLayerMap';
import { getIconUrl } from '../../../services/asset';
import { useLocation } from '../../../routes/Configuration/hooks';
import { getLength } from "ol/sphere"
import { LineString } from 'ol/geom';

import { Alert } from "antd"

type Props = {
  onChange: (value: any) => void;
  value: any;
}

const MAP_ELEMENT_NAME = "map"
const WARNING_DISTANCE_LENGTH = 10000 // 10km


const MapLocationPicker = ({ onChange, value }: Props) => {
  const isMobile = isMobileScreen(getWindowWidth());
  const [isDistanceWarningShown, setIsDistanceWarningShown] = useState(false);
  // Settlement coordinates come from configuration/locations/:id
  const settlementResource = useLocation(value.settlementId);


  useEffect(() => {
    if (!settlementResource || !(value.latitude && value.longitude)) return;

    if (settlementResource && settlementResource.latitude && settlementResource.longitude) {
      const coordStart = [settlementResource.longitude, settlementResource.latitude]
      const coordEnd = [value.longitude, value.latitude]

      const line = new LineString([coordStart, coordEnd]);
      const distance = getLength(line, { projection: 'EPSG:4326' });

      setIsDistanceWarningShown(distance > WARNING_DISTANCE_LENGTH);
    }

  }, [settlementResource, value.latitude, value.longitude])

  const zoomHint = useZoomHint(MAP_ELEMENT_NAME)

  const handleChange = (change) => {
    onChange({
      ...value,
      ...change
    })
  }


  const { handleReturnToLocation } = useOpenLayerMap(MAP_ELEMENT_NAME, value, handleChange)

  const handleLocationChange = (e) => {
    // if circle is selected, randomize coordinates a bit
    onChange({
      ...value,
      isPreciseLocation: e.target.value === "marker",
    })

  }

  return (
    <div className={styles.mapContainer}>
      <div style={{ position: 'relative' }}>
        {isDistanceWarningShown && (
          <Alert
            type='warning'
            message="Odabrano naselje i lokacija na mapi su udaljeni više od 10km. Molimo provjerite ispravnost lokacije."
            style={{ marginBottom: 10 }}
          />
        )}
        <div id={MAP_ELEMENT_NAME} className={styles.mapLocationPickerWrapper}>
          <button
            className={styles.returnToLocationButton}
            onClick={handleReturnToLocation}
            title="Vrati na lokaciju"
          >
            <img src={getIconUrl("focus_pin.svg")} style={{ marginRight: 0 }} />
          </button>
        </div>

        <div className={styles.zoomHint} style={{ opacity: zoomHint === ZOOM_HINT_STATE.shown ? 1 : 0 }}>
          {isMobile ? "Koristi dva prsta za zumiranje karte" : "Pritisni CTRL + scroll za zumiranje karte"}
        </div>
      </div>

      <div className={styles.modeSelector}>
        <Radio.Group
          value={value.isPreciseLocation ? "marker" : "circle"}
          onChange={handleLocationChange}
        >
          <div style={{ display: 'flex', flexDirection: isMobile ? "column" : "row" }}>
            <Radio value="marker">Koristi točnu lokaciju</Radio>
            <Radio value="circle">Koristi okvirnu lokaciju</Radio>
          </div>
        </Radio.Group>
      </div>
    </div>
  )
}

export default MapLocationPicker;






// WEBPACK FOOTER //
// ./src/containers/AdFormPage/LocationSelector/MapLocationPicker.tsx